import TableEditItem from './table-edit-item.vue'
import {
  DatePicker,
  TimePicker,
  Select
} from 'element-ui'

TableEditItem.$$components = {
  'date-picker': {
    component: DatePicker
  },
  'time-picker': {
    component: TimePicker
  },
  'select': {
    component: Select
  }
}

TableEditItem.registerComponents = function (opt) {
  Object.assign(TableEditItem.$$components, opt)
}

export default TableEditItem
